import Vue from 'vue';
import Router from 'vue-router';
//import Home from '@/components/Home';

import Landing from '@/components/End';
import firebase from 'firebase';

const Perguntas = () => import('@/components/Perguntas')
const Status = () => import('@/components/Status')
const Admin = () => import('@/components/Admin')
const Pergunta1 = () => import('@/components/Pergunta1')
const Pergunta2 = () => import('@/components/Pergunta2')
const Pergunta3 = () => import('@/components/Pergunta3')
const Pergunta4educ = () => import('@/components/Pergunta4educ')
const Pergunta4cultura = () => import('@/components/Pergunta4cultura')
const Pergunta4esport = () => import('@/components/Pergunta4esport')
const Pergunta5 = () => import('@/components/Pergunta5')
const Pergunta6 = () => import('@/components/Pergunta6')
const Pergunta7 = () => import('@/components/Pergunta7')
const Pergunta8 = () => import('@/components/Pergunta8')
const Verificacao = () => import('@/components/Verificacao')


Vue.use(Router);

let routes = [ 
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        requiresGuest: true
        
      }
    },       
    {
      path: '/status',
      name: 'Status',
      component: Status,
      meta: {
        requiresAuth: true
      }      
    },
    {
      path: '/',
      name: 'landing',
      component: Landing     
    },
    {
      path: '/*',
      name: 'landing',
      component: Landing     
    },    
    /* {
      path: '/perguntas',
      name: 'Perguntas',
      component: Perguntas      
    },
    {
      path: '/administracao-e-gestao',
      name: 'Pergunta1',
      component: Pergunta1      
    },
    {
      path: '/assistencia-social',
      name: 'Pergunta2',
      component: Pergunta2      
    },
    {
      path: '/desenvolvimento-economico',
      name: 'Pergunta3',
      component: Pergunta3     
    },
    {
      path: '/educacao',
      name: 'Pergunta4educ',
      component: Pergunta4educ     
    },
    {
      path: '/cultura',
      name: 'Pergunta4cultura',
      component: Pergunta4cultura     
    },
    {
      path: '/esporte-e-lazer',
      name: 'Pergunta4esport',
      component: Pergunta4esport     
    },    
    {
      path: '/governo-e-comunicacao-social',
      name: 'Pergunta5',
      component: Pergunta5      
    },
    {
      path: '/obras-servicos-urbanos-mobilidade-e-habitacao',
      name: 'Pergunta6',
      component: Pergunta6
      
    },
    {
      path: '/planejamento-urbanismo-e-meio-ambiente',
      name: 'Pergunta7',
      component: Pergunta7      
    },
    {
      path: '/saude',
      name: 'Pergunta8',
      component: Pergunta8     
    },           
    {
      path: '/entrar',
      name: 'Vericacao',
      component: Verificacao
       
    }   */
  ]


 let router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
});


// Nav Guard
router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/admin',
        query: {
          redirect: '/status'
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if NO logged user
    if (firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/status',
        query: {
          redirect: '/status'
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
});

export default router;
